module.exports = __webpack_public_path__ + "static/media/2020.11.5卫生院助力艾条制作活动.302c4d9d.jpg";